import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { forwardRef } from 'react';
import { useComponentTheme } from '@chegg-ui/theme';
import { ChevronIcon } from '@chegg-ui/horizon-icons';
import { ButtonLabel } from '../shared';
import { CourseButtonContainer, getCourseThemeConfig } from '../styles';
var CourseButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      dataTest = _ref['data-test'],
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 'auto' : _ref$width,
      theme = _ref.theme,
      leadingIcon = _ref.leadingIcon,
      trailingIcon = _ref.trailingIcon,
      buttonProps = _objectWithoutProperties(_ref, ["children", "size", "data-test", "type", "width", "theme", "leadingIcon", "trailingIcon"]);

  var componentTheme = useComponentTheme({
    name: 'CourseButton',
    theme: getCourseThemeConfig(theme)
  });
  return /*#__PURE__*/React.createElement(CourseButtonContainer, _extends({}, buttonProps, {
    "data-test": dataTest ? dataTest : undefined,
    size: componentTheme.showChevronTrailingIcon ? 'xlarge' : size,
    ref: ref,
    type: type,
    width: width,
    customTheme: componentTheme,
    disableHoverAnimation: true
  }), /*#__PURE__*/React.createElement(ButtonLabel, {
    size: componentTheme.showChevronTrailingIcon ? 'xlarge' : size,
    customTheme: componentTheme,
    leadingIcon: leadingIcon,
    trailingIcon: componentTheme.showChevronTrailingIcon ? /*#__PURE__*/React.createElement(ChevronIcon, {
      pointing: "right"
    }) : trailingIcon,
    alignTrailingIconToRight: componentTheme.showChevronTrailingIcon ? true : false,
    useCustomIconSize: true
  }, children));
});
CourseButton.displayName = 'CourseButton';
export default CourseButton;